import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "ulties-cookie-consent";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (typeof window === "undefined") return;
      if (!localStorage.getItem(KEY)) setOpen(true);
    }, 900);
    return () => clearTimeout(t);
  }, []);

  const close = (choice) => {
    try {
      localStorage.setItem(KEY, JSON.stringify({ choice, at: Date.now() }));
    } catch {
      /* storage may be unavailable (private mode) — best effort only */
    }
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60]"
        >
          <div className="rounded-2xl border border-black/10 dark:border-white/10 bg-white/95 dark:bg-[#0a0a0a]/95 backdrop-blur-2xl shadow-[0_30px_80px_-30px_rgba(0,0,0,0.6)] p-5 md:p-6">
            <div className="flex items-start gap-3">
              <div className="h-8 w-8 shrink-0 rounded-full bg-zinc-900 dark:bg-white text-white dark:text-black flex items-center justify-center text-[13px]">
                🍪
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-display text-base font-medium tracking-tight text-zinc-900 dark:text-white">
                  We use minimal cookies.
                </h3>
                <p className="mt-1.5 text-[13px] leading-relaxed text-zinc-600 dark:text-zinc-400">
                  Strictly-necessary cookies keep the site working. We&apos;d
                  also like to set analytics cookies to understand what people
                  find useful. You can change this anytime.
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-2">
                  <button
                    type="button"
                    data-testid="cookie-accept"
                    onClick={() => close("accept")}
                    className="inline-flex items-center justify-center rounded-full bg-zinc-900 dark:bg-white text-white dark:text-black px-4 py-2 text-xs font-medium hover:opacity-90 transition-opacity"
                  >
                    Accept all
                  </button>
                  <button
                    type="button"
                    data-testid="cookie-reject"
                    onClick={() => close("reject")}
                    className="inline-flex items-center justify-center rounded-full border border-black/10 dark:border-white/10 px-4 py-2 text-xs font-medium text-zinc-700 dark:text-zinc-300 hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
                  >
                    Only necessary
                  </button>
                  <a
                    href="#"
                    onClick={(e) => e.preventDefault()}
                    className="ml-auto text-[11px] tracking-[0.18em] uppercase text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-200 transition-colors"
                  >
                    Preferences
                  </a>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
